// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1212":"61e2cf65a0c88b3c","2741":"653c787f2490dc24","5351":"1ea420bf617b3799","8206":"694568ff0a3d447d","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};